import { Modal, IconButton } from "@fluentui/react";
import { useState, useEffect } from "react";
import styles from "./AnalysisPanel.module.css";
import { SupportingContent } from "../SupportingContent";
import { ChatAppResponse } from "../../api";
import { AnalysisPanelTabs } from "./AnalysisPanelTabs";
import { ThoughtProcess } from "./ThoughtProcess";
import { MarkdownViewer } from "../MarkdownViewer";

interface Props {
    className: string;
    activeTab: AnalysisPanelTabs;
    onActiveTabChanged: (tab: AnalysisPanelTabs) => void;
    activeCitation: string | undefined;
    citationHeight: string;
    answer: ChatAppResponse;
}

export const AnalysisPanel = ({ answer, activeTab, activeCitation, citationHeight, className, onActiveTabChanged }: Props) => {
    const isDisabledCitationTab: boolean = !activeCitation;
    const [citation, setCitation] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);


    const fetchCitation = async () => {
        if (activeCitation) {
            try {
                 const originalHash = activeCitation.indexOf("#") ? activeCitation.split("#")[1] : "";
                const response = await fetch(activeCitation, {
                    method: "GET",
                });
                if (!response.ok) {
                    console.error(`Failed to fetch citation: ${response.status} ${response.statusText}`);
                    return;
                }
                const citationContent = await response.blob();
                let citationObjectUrl = URL.createObjectURL(citationContent);
                 if (originalHash) {
                    citationObjectUrl += "#" + originalHash;
                }
                setCitation(citationObjectUrl);
            } catch (error) {
                console.error("Error fetching citation:", error);
            }

        }
    };

    useEffect(() => {
        if (activeTab === AnalysisPanelTabs.CitationTab && activeCitation) {
            fetchCitation();
            setIsModalOpen(true);
        }
    }, [activeTab, activeCitation]);

    const renderFileViewer = () => {
        if (!activeCitation) {
            return null;
        }

        const fileExtension = activeCitation.split(".").pop()?.toLowerCase();
        switch (fileExtension) {
            case "png":
                return <img src={citation} className={styles.citationImg} alt="Citation Image" />;
            case "md":
                return <MarkdownViewer src={activeCitation} />;
            default:
                return <iframe title="Citation" src={citation} width="100%" height={citationHeight} />;
        }
    };

    const closeModal = () => {
        setIsModalOpen(false);
        onActiveTabChanged(AnalysisPanelTabs.ThoughtProcessTab); // Or any default tab you prefer
    };

    return (
        <>
            <Modal
                isOpen={isModalOpen}
                onDismiss={closeModal}
                isBlocking={false}
                containerClassName={styles.modalContainer}
            >
                <div className={styles.modalHeader}>
                    <strong>Reference</strong>
                    <IconButton
                        iconProps={{ iconName: "Cancel" }}
                        ariaLabel="Close popup modal"
                        onClick={closeModal}
                    />
                </div>
                <div className={styles.modalBody}>
                    {renderFileViewer()}
                </div>
            </Modal>
        </>
    );
};